import type { InvoiceDocumentKindType } from 'features/Enterprise/Vendor/services/vendorInvoice'

export type InvoiceFileDownloadTypeIdType = 'seller' | 'commercial-purchase-order'

export const resolveInvoiceFileDownloadTypeId = (
  filePath: string,
  documentType?: InvoiceDocumentKindType,
): InvoiceFileDownloadTypeIdType => {
  if (documentType === 'po' || filePath.includes('commercial-purchase-order')) {
    return 'commercial-purchase-order'
  }
  return 'seller'
}
